module.exports = __webpack_public_path__ + "h5/img/ege.eed7e24e.png";